import { Component, Output, EventEmitter, ViewChild, ElementRef, Input } from '@angular/core';

import { AlertService } from 'src/app/services/alert.service';

@Component({
  selector: 'app-file-upload',
  templateUrl: './file-upload.component.html',
  styleUrls: ['./file-upload.component.scss']
})
export class FileUploadComponent {
  @Output() public upload = new EventEmitter<any>();

  @Input() public fileTypes = {
    'application/pdf': 'document',
    'image/png': 'image',
    'image/jpg': 'image',
    'image/jpeg': 'image',
    'audio/mpeg': 'podcast',
    'video/mp4': 'video'
  };
  @Input() public multiple = true;
  @Input() public confirm = false;
  @Input() public disabled = false;
  @Input() public uploading = false;
  @Input() public uploadProgress: { [index: string]: number } = {};
  @Input() public buttonText = 'Add';
  @Input() public icon = 'plus-circle';

  public uploadFiles: any[] = [];

  @ViewChild('filesInput', { static: true }) public filesInput: ElementRef<HTMLInputElement>;

  public get accept() {
    if (!this.fileTypes) {
      return '*';
    }
    return Object.keys(this.fileTypes);
  }

  public get uploadValue() {
    let c = 0;

    for (const f of this.uploadFiles) {
      c += this.uploadProgress[f.file.name];
    }

    return c;
  }

  public get uploadedCount() {
    return this.uploadFiles.filter(a => this.uploadProgress[a.file.name] === 100).length;
  }

  constructor(private alert: AlertService) {}

  public startUploading() {
    this.upload.emit(this.uploadFiles);
    this.filesInput.nativeElement.value = null;
  }

  public reset() {
    this.filesInput.nativeElement.value = null;
    this.uploadFiles = [];
    this.uploadProgress = {};
    this.uploading = false;
  }

  public addUploadFile() {
    this.filesInput.nativeElement.click();
  }

  public removeUploadFile(file: File) {
    this.filesInput.nativeElement.value = null;
    this.uploadFiles = this.uploadFiles.filter(f => f !== file);
  }

  public async uploadFilesChange(evt: Event) {
    const target = evt.target as HTMLInputElement;

    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for (let i = 0; i < target.files.length; i++) {
      const f = target.files[i];
      if (f.name in this.uploadProgress) {
        continue;
      }

      if (!(f.type in this.fileTypes)) {
        const suffixes = Object.keys(this.fileTypes).map(t => t.split('/')[1]);
        await this.alert.fireConfirm(
          `${f.name} has an unsupported File Type`,
          'Please only upload files with the suffix ' + suffixes.join(', ')
        );
        continue;
      }

      this.uploadProgress[f.name] = 0;
      this.uploadFiles.push({
        originalTitle: f.name,
        title: f.name,
        file: f
      });
    }

    if (this.uploadFiles.length == 0) {
      return this.reset();
    }
    if (!this.confirm) {
      return this.startUploading();
    }
  }
}
